import styled from 'styled-components'
import React, { useEffect, useRef, useState } from 'react'
import LabelField from './LabelField'
import theme from '../utils/theme'
import { Description, Error } from './Text'
import { getNextCursorPosition, setSelection } from '../utils/util'
import Icon from './Icon'

const InputContainer = styled.input`
    border: 1px solid ${ theme.palette.black };
    background: ${ theme.palette.white };
    padding: 8px 10px;
    font-size: 12px;
    border-radius:0;
    color: ${ theme.palette.black };
    &.error {
      border: 1px solid ${ theme.palette.red };
    }
    &.validated {
      border: 1px solid ${ theme.palette.green };
    }
    &:focus {
        border: 1px solid ${ theme.palette.blue };
        background: #FFFFFF
    }
    
    &::placeholder {
      color: ${ theme.palette.grey };
    }
    &:disabled {
      background: ${ theme.palette.grey };
    }
`

const Suffix = styled.span`
  margin-left: 5px;
  font-size: 14px;
`

const Input = ({
                 label, formatter, value, subLabel, direction = 'column', required, optional,
                 onValueChange, error, validated, className, labelClassName, suffix, description, icon,
                 ...props

               }) => {
  let cn = className || ''
  if (error) {
    cn += ' error'
  } else if (validated) {
    cn += ' validated'
  }
  const [raw, setRaw] = useState('')
  const [current, setCurrent] = useState('')
  const [cursor, setCursor] = useState(0)
  const inputEl = useRef(null)


  useEffect(() => {
    if (formatter && (value || value === '' || value === 0)) {
      setRaw(value)
      const currentValue = formatter ? formatter.format(value) : value
      setCurrent(currentValue)
    }
  }, [value, formatter])

  useEffect(() => {
    if (inputEl && formatter) {
      setSelection(inputEl, cursor, document)
    }
  }, [inputEl, cursor, formatter, current])

  const valueChange = (ev) => {
    if (formatter) {
      const endCursorPos = ev.target.selectionEnd
      const currentValue = ev.target.value
      const rawValue = formatter.getRawValue(currentValue)
      const nextCursorPos = getNextCursorPosition(endCursorPos, current, currentValue, formatter.delimiter, formatter.delimiters)
      ev.target.value = formatter.format(rawValue)
      setCursor(nextCursorPos)
      if (rawValue !== raw) {
        setRaw(rawValue)
        onValueChange && onValueChange(rawValue)
      }
    } else {
      const rawValue = ev.target.value
      onValueChange && onValueChange(rawValue)
    }
  }

  const input = <InputContainer
    ref={ inputEl } className={ cn }
    onChange={ valueChange } value={ formatter ? current : (value || '') } { ...props }/>
  const suffixText = <Suffix> { suffix } </Suffix>
  return <LabelField label={ label } subLabel={ subLabel } direction={ direction } className={ labelClassName }
                     required={ required } optional={ optional }>
    { suffix ? (direction === 'column' ? <div>
        { input }
        { suffixText }
      </div> : <React.Fragment>
        { input }
        { suffixText }
      </React.Fragment>)
      : input
    }
    { icon ? <Icon name={ icon }/> : null }
    { description && <Description>{ description }</Description> }
    { error && <Error>{ error }</Error> }
  </LabelField>
}

export default Input
